/**
 * Reusable Button component.
 *
 * Variants:
 *   primary  — teal fill (main CTAs)
 *   outline  — teal border, transparent fill (secondary CTAs)
 *   accent   — amber fill (download / highlight CTAs)
 */

const VARIANTS = {
  primary:
    'bg-primary text-white hover:bg-primary-dark focus-visible:ring-primary',
  outline:
    'border-2 border-primary text-primary bg-transparent hover:bg-primary-light focus-visible:ring-primary',
  accent:
    'bg-accent text-white hover:bg-accent-dark focus-visible:ring-accent',
}

export default function Button({
  children,
  variant = 'primary',
  className = '',
  as: Tag = 'button',
  ...props
}) {
  const base =
    'inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg text-sm font-semibold ' +
    'transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ' +
    'disabled:opacity-50 disabled:cursor-not-allowed ' +
    'hover:scale-[1.02] active:scale-[0.98]'

  return (
    <Tag className={`${base} ${VARIANTS[variant]} ${className}`} {...props}>
      {children}
    </Tag>
  )
}
